// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as FareEstimateStore$PorterinFeature from "../../shared/core/constants/FareEstimateStore.mjs";

function defaultValue_set_is_serviceable_pickup(param) {
  
}

function defaultValue_set_is_serviceable_dropoff(param) {
  
}

function defaultValue_set_sender(param) {
  
}

function defaultValue_set_receiver(param) {
  
}

var defaultValue = {
  is_serviceable_pickup: true,
  is_serviceable_dropoff: true,
  set_is_serviceable_pickup: defaultValue_set_is_serviceable_pickup,
  set_is_serviceable_dropoff: defaultValue_set_is_serviceable_dropoff,
  sender: FareEstimateStore$PorterinFeature.default_customer_address,
  set_sender: defaultValue_set_sender,
  receiver: FareEstimateStore$PorterinFeature.default_customer_address,
  set_receiver: defaultValue_set_receiver
};

var context = React.createContext(defaultValue);

function useAddressContext(param) {
  return React.useContext(context);
}

export {
  defaultValue ,
  context ,
  useAddressContext ,
}
/* context Not a pure module */
